/**
 * visualMap component entry
 */


    require('./visualMapContinuous');
    require('./visualMapPiecewise');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/visualMap.js
// module id = 302
// module chunks = 1